import React, {  useContext } from "react";
import _ from "lodash";
import { renderHeaderTable } from "./SummaryHeader";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import { SummaryContext } from "../../context/SummaryContext";
import { ReactComponent as File } from "../../assets/icons/video.svg";
import { UserContext } from "../../context/UserContext";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

const SourceSummary = () => {
  const jobTypes = ConfigUtils.getJobTypes();
  const { job, sourceHeaders } = useContext(SummaryContext);
  const { userRole } = useContext(UserContext);
  const jobType = _.find(jobTypes, (jobTypeObject) => _.get(jobTypeObject, "jobType") === _.get(job, "jobType"));
  const sourceLocationFields = ConfigUtils.getSourceLocations();
  const newIdType = _.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole) &&
    _.get(job, "requests[0].sourceType") === "MEDIA_SUPPLY_CHAIN" ?
    _.find(sourceLocationFields, ["value", _.get(job, "source.sourceLocation.newLocationSubType")]) : _.find(_.get(jobType, "sourceDefinition", []), (sourceDef) => _.get(sourceDef, "type") === _.get(job, "requests[0].sourceType"));
  const source = newIdType ??
    _.find(_.get(jobType, "sourceDefinition", []), (sourceDef) => _.get(sourceDef, "type") === _.get(job, "source.sourceLocation.locationSubType"))

  return _.isEmpty(job) || !_.has(job, "source")
    ? null
    : renderHeaderTable(
        sourceHeaders,
        JobUtils.updateSourceField(_.get(job, "source")),
        `Source: ${_.get(source, "label", "")}`,
        <File />
      );
};

export default SourceSummary;
